const APPLIED_TYPE = {
  all: 'Toàn trường',
  grade: 'Theo khối',
  custom: 'Đối tượng cụ thể'
}

const APPLIED_TYPE_SELECT_ITEMS = [
  { title: 'Toàn trường', value: 'all' },
  { title: 'Theo khối', value: 'grade' },
  // { title: 'Đối tượng cụ thể', value: 'custom' }
]

const EVENT_TABLE_HEADERS = [
  { text: 'Tiêu đề', value: 'title' },
  { text: 'Thời gian diễn ra', value: 'fromTo' },
  { text: 'T.Thái hiển thị', value: 'isPublished', align: 'center' },
  { text: 'T.Thái đăng ký', value: 'isOpenRegistration', align: 'center' },
  { text: 'T.Thái hết hạn', value: 'isExpired', align: 'center' },
  { text: 'Đối tượng áp dụng', value: 'appliedType', align: 'center' },
  { text: 'Thao tác', align: 'end', value: 'actions' }
]

export default { EVENT_TABLE_HEADERS, APPLIED_TYPE, APPLIED_TYPE_SELECT_ITEMS }
